import { render, staticRenderFns } from "./right.vue?vue&type=template&id=3d88a9bc&scoped=true"
import script from "./right.vue?vue&type=script&lang=js"
export * from "./right.vue?vue&type=script&lang=js"
import style0 from "./right.vue?vue&type=style&index=0&id=3d88a9bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d88a9bc",
  null
  
)

export default component.exports